<template>
  <div class="relative overflow-hidden preview-root" v-bind:style="{ 'background-color': skin.page_background_color }">
    <confetti
      class="absolute-fill"
      style="z-index: 3;"
      :effect="skin.open_effect"
      :active="!!skin.open_effect"
    />
    <div v-if="skin.music" class="absolute d-flex align-end" style="bottom: 5%; right: 5%; z-index: 2; width: 18%;">
      <v-icon size="100%" color="grey" v-html="mdiMusic" />
    </div>
    <card-background style="z-index: 0;" :src="skin.page_background_img" :scale="bgScale" />
    <div class="fill-height" style="z-index: 1; padding: 5%;">
      <envelope
        ref="env" key="env"
        class="fill-height"
        :skin="skin" :from="from" :to="to" :aspect-ratio="isStandaloneGroupVideo ? 16 / 9 : 5 / 7"
      >
        <template v-if="card" v-slot:default="{ w }">
          <v-card v-if="isStandaloneGroupVideo" color="black">
            <v-responsive :aspect-ratio="16 / 9" content-class="d-flex justify-center align-center">
              <v-btn class="absolute" v-bind:style="{ transform: `scale(${.0025 * w + .25})` }" fab color="primary">
                <v-icon x-large v-html="mdiPlay" />
              </v-btn>
            </v-responsive>
          </v-card>
          <card-preview
            v-else
            key="card"
            class="v-card v-sheet"
            :mode="mode || 'view'"
            :card="card"
            :is-card-owner="true"
            :width="w"
          />
        </template>
      </envelope>
    </div>
  </div>
</template>


<style scoped>
.preview-root {
  cursor: pointer;
  transition: background-color 1s, filter .15s;
}
.preview-root:hover {
  filter: brightness(85%);
}
</style>


<script>
import CardBackground from '@/components/CardBackground.vue';
import CardPreview from '@/components/CardPreview.vue';
import Confetti from '@/components/Confetti.vue';
import Envelope from '@/components/Envelope.vue';
import { nullCoverDesignId } from '@/mixins/public-design.js';
import { mdiPlay, mdiMusic } from '@mdi/js';


export default {
  name: 'skin-preview',

  components: {
    CardBackground,
    CardPreview,
    Confetti,
    Envelope
  },

  props: [ 'skin', 'from', 'to', 'card', 'mode', 'bgScale' ],

  data() {
    return {
      paused: false
    };
  },

  computed: {
    isStandaloneGroupVideo() {
      return this.card?.design_id == nullCoverDesignId;
    },

    isAnimating() {
      return ![ 'opened', 'closed' ].includes(this.$refs.env?.state);
    }
  },

  created() {
    this.pausedPromise = Promise.resolve();
    Object.assign(this, { mdiPlay, mdiMusic });
  },

  mounted() {
    if (this.card)
      this.loop();
  },

  destroyed() {
    clearTimeout(this.t);
  },

  methods: {
    async loop() {
      while (true) {
        for (const fn of [ 'open', 'close' ]) {
          this.active = fn;
          await new Promise(r => this.t = setTimeout(r, 3000));
          await this.pausedPromise;
          if (!this.$refs.env)
            break;
          await this.$refs.env[fn](3000);
        }
      }
    }
  },

  watch: {
    paused(v) {
      if (v) {
        this.pausedPromise = new Promise(r => this.pausedPromiseResolve = r);
        this.$refs.env.finishAnimation();
      } else if (this.pausedPromiseResolve) {
        this.pausedPromiseResolve();
      }
    }
  }
}
</script>
